import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Config} from "./Config";
import {lastValueFrom} from 'rxjs';

@Injectable()
export class ConfigService {
    static config: Config;

    constructor(private readonly http: HttpClient) {
        // Try to detect and load environment-specific config
    }

    /**
     * Detect which config file to load based on hostname or environment
     */
    private detectConfigFile(): string {
        const hostname = window.location.hostname;
        const configMap: { [key: string]: string } = {
            'localhost': 'assets/localhost-config.json',
            '127.0.0.1': 'assets/localhost-config.json',
        };

        // Check if there's a matching config file for the hostname
        for (const [host, configFile] of Object.entries(configMap)) {
            if (hostname.includes(host)) {
                return configFile;
            }
        }

        // Default to assets/config.json
        return 'assets/config.json';
    }

    getConfig() {
        const configUrl = this.detectConfigFile();
        return lastValueFrom(this.http.get<Config>(configUrl))
            .then(data => {
                if (data && typeof data === 'object') {
                    ConfigService.config = {...data};
                } else {
                    throw new Error('Invalid config data received');
                }
            })
            .catch(error => {
                console.error(`Failed to load config from ${configUrl}:`, error);
                // Set a default/fallback config to prevent undefined errors
                ConfigService.config = this.getDefaultConfig();
                console.warn('Using default configuration');
            });
    }

    /**
     * Provide a default config to prevent undefined errors
     */
    private getDefaultConfig(): Config {
        return {
            production: false,
            version: '0.0.0',
            versionCheckFrequency: 60000,
            federatedSSOName: '',
            powerdataDomain: 'localhost',
            pdUiServiceUrl: 'http://localhost:8011/ws',
            redirectUri: 'http://localhost:8055/oauth2/authorize',
            refreshAccessTokenUri: 'http://localhost:8055/oauth2/refresh-access-token',
            userInfoUrl: 'http://localhost:9494/admin/userInfo',
            userServiceUrl: 'http://localhost:9494/v1/admin',
            targetUri: 'http://localhost:4200/appconsole',
            restApiUrl: 'http://localhost:9494/v1',
            brokerServiceUrl: 'http://localhost:8022/v1',
            documentServiceUrl: 'http://localhost:8015',
            dbhServiceUrl: 'http://localhost:8025',
            geofenceServiceUrl: 'http://localhost:8028',
            logoutRedirectUri: 'http://localhost:4200/session/logout',
            loginRedirectUri: 'http://localhost:4200/session/login',
            logoutUrl: 'http://localhost:8055/oauth2/logout',
            iotGwServiceUrl: 'http://localhost:8170',
            mapServiceUrl: 'http://localhost:8099'
        };
    }
}
